
import { Injectable } from '@angular/core';
import { BackendService } from '../../backend.service';
import { Observable } from 'rxjs';
import { TokenService } from '../../token/token.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class DownpaymentService {

  private juspayCreateOrderUrl = '/juspay/api/v1/order/createOrder';
  private payuCreateOrderUrl = '/payu/initiatePayUTxn';
  private getPaymentStatusUrl = '/Repayments/Payments/LoanApplication/{loanApplicationId}/InitialPayment';
  private getPaymentDetailsUrl = '/ApplicationFlow/LoanApplications/{loanApplicationId}/InitialPayment';
  private repaymentsUrl = '/Repayments/Payments';
  private successUrl = '/application/payment';
  private failUrl = '/application/payment?error=true';
  private juspayPendingTransactionurl = '/juspay/api/v1/order/verifyPendingTxns/{loanApplicationId}';
  private payUPendingTransactionurl = '/payu/verifyPayUPendingTxns/{loanApplicationId}';
  private dpPendingWithoutAuthUrl = '/juspay/api/v1/order/verifyDpStatus/{loanApplicationId}';

  constructor(private backendService: BackendService, private tokenService: TokenService) { }

  createOrder(applicationId: string) {
    let url: string;
    if (environment.downpaymentMethod.JusPay) {
      url = this.juspayCreateOrderUrl;
    } else if (environment.downpaymentMethod.PayU) {
      url = this.payuCreateOrderUrl;
    }
    let lc = '';
    if (!window.location.origin) {
      lc = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
    } else {
      lc = window.location.origin;
    }
    const failUrl = lc + this.failUrl;
    const successUrl = lc + this.successUrl;
    const applicationData = {
      'applicationId': applicationId,
      'surl': successUrl,
      'furl': failUrl
    };
    return this.backendService.setData(url, applicationData);
  }
  getDetails(loanApplicationId: string) {
    return this.backendService.getData(this.getPaymentDetailsUrl.replace('{loanApplicationId}', loanApplicationId));
  }
  getDownPaymentStatus(loanApplicationId): Observable<any> {
    return this.backendService.getData(this.getPaymentStatusUrl.replace('{loanApplicationId}', loanApplicationId));
  }
  getPendingTransaction(loanApplicationId: string) {
    let url: string;
    if (environment.downpaymentMethod.JusPay) {
      url = this.juspayPendingTransactionurl;
    } else if (environment.downpaymentMethod.PayU) {
      url = this.payUPendingTransactionurl;
    }
    return this.backendService.getData(url.replace('{loanApplicationId}', loanApplicationId));
  }
  getPendingTranscationWithoutCustomerId(loanApplicationId: string) {
    return this.backendService.getData(this.dpPendingWithoutAuthUrl.replace('{loanApplicationId}', loanApplicationId));
  }
  setCashOnDelivery(loanApplicationId: string) {
    const postDetails = {
      CustomerId: this.tokenService.getCustomerId(),
      ApplicationId: loanApplicationId,
      PaymentType: 'InitialPayment',
      PaymentOption: 'CashOnDelivery'
    };
    return this.backendService.setData(this.repaymentsUrl, postDetails);
  }
  getRepaymentsData(loanApplicationId: string) {
    return this.backendService.getData(this.getPaymentStatusUrl.replace('{loanApplicationId}', loanApplicationId));
  }
}
